export const UPLOAD_IMAGE_TO_FIREBASE = true
export const IMAGE_FILE_TYPE = ["JPG", "PNG", "JPEG", "WEBP"];
IMAGE_FILE_TYPE.join = () => Array.prototype.join.call(IMAGE_FILE_TYPE, ", ");
export const IMAGE_FILE_SIZE = 1024 * 1024 * 10;


export const SYSTEM_NOTIFICATION_TYPES = {
    CREATE_ACTIVITY: 'create_activity',
    CREATE_QUIZ: 'create_quiz',
    UPDATE_QUIZ: 'update_quiz',
    UPDATE_ACTIVITY: 'update_activity',
    DELETE_ACTIVITY: 'delete_activity',
    DELETE_QUIZ: 'delete_quiz',
    CREATE_NOTE: 'create_note',
    UPDATE_NOTE: 'update_note',
    DELETE_NOTE: 'delete_note',
    CREATE_ASSIGNMENT: 'create_assignment',
    UPDATE_ASSIGNMENT: 'update_assignment',
    DELETE_ASSIGNMENT: 'delete_assignment',
    CREATE_ASSIGNMENT: 'create_assignment',
    UPDATE_ASSIGNMENT: 'update_assignment',
    DELETE_ASSIGNMENT: 'delete_assignment',
}